import React from 'react';
import { Article } from '@/types';
import { getMediaUrl } from '@/services/api';

interface ArticlesGridProps {
  articles: Article[];
  onArticleClick: (article: Article) => void;
  className?: string;
}

const ArticlesGrid: React.FC<ArticlesGridProps> = ({
  articles = [], // Default to empty array if undefined
  onArticleClick,
  className = ''
}) => {
  // Ensure articles is an array and has items
  const safeArticles = Array.isArray(articles) ? articles : [];
  
  if (safeArticles.length === 0) {
    return (
      <div className={`empty-state ${className}`}>
        <p>No articles available. Check back soon for updates!</p>
      </div>
    );
  }

  return (
    <div className={`articles-grid ${className}`}>
      {safeArticles.map((article) => (
        <div 
          key={article.id} 
          className="article-card"
          onClick={() => onArticleClick(article)}
        >
          {article.image1 && (
            <div className="article-image">
              <img 
                src={getMediaUrl(article.image1)} 
                alt={article.title}
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                }}
                loading="lazy"
              />
            </div>
          )}
          <div className="article-content">
            <span className="article-date">{article.date}</span>
            <h3>{article.title}</h3>
            <p className="subtitle">{article.subtitle}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ArticlesGrid;
